import './AppImageBackground.css';

interface AppImageBackgroundProps {
    children: JSX.Element[],
    placeholderBackground: string,
    background: string
}

function AppImageBackground({ placeholderBackground, background, children }: AppImageBackgroundProps) {
    return <>

        <div className='app-image-background' style={{ backgroundImage: `url(${background})` }}></div>

        <div className='background-placeholder' style={{ backgroundImage: `url(${placeholderBackground})` }}>
            <div className='backdrop-filter'></div>
        </div>
        
        <div className='content-wrapper'>
            {children}
        </div>


    </>
}

export default AppImageBackground